module.exports = __webpack_public_path__ + "static/media/flyer-italy-promo-12mm.6fa3bce6.pdf";